import { render, staticRenderFns } from "./ProvideSecurity.vue?vue&type=template&id=7dee3b7c&"
import script from "./ProvideSecurity.vue?vue&type=script&lang=js&"
export * from "./ProvideSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports